var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 43,
    rx: 9.5,
    fill: "white",
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.04 11.16H18.12V9.96C18.12 9.4305 17.6895 9 17.16 9H12.36C11.8305 9 11.4 9.4305 11.4 9.96V11.16H9.48C9.2145 11.16 9 11.3745 9 11.64V12.12C9 12.186 9.054 12.24 9.12 12.24H10.026L10.3965 20.085C10.4205 20.5965 10.8435 21 11.355 21H18.165C18.678 21 19.0995 20.598 19.1235 20.085L19.494 12.24H20.4C20.466 12.24 20.52 12.186 20.52 12.12V11.64C20.52 11.3745 20.3055 11.16 20.04 11.16ZM17.04 11.16H12.48V10.08H17.04V11.16Z",
    fill: "#636467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteNew);
export default __webpack_public_path__ + "static/media/iconDeleteNew.00579af1.svg";
export { ForwardRef as ReactComponent };